import React from "react";
import MarketingPage from "./MarketingPage";
import { Layers, FileCheck2, Sparkles, Upload, ShieldCheck, GitBranch, FolderOpen, Users2, FileText } from "lucide-react";

const features = [
  {icon: Layers, title:"Document standardisation", body:"Bring existing documents into the current company standard, structure and terminology."},
  {icon: FileCheck2, title:"Template intelligence", body:"Reuse your organisation's approved Word templates and section structures."},
  {icon: Sparkles, title:"Document generation", body:"Turn rough information into structured formal documentation with your standards applied."},
  {icon: Upload, title:"Multi-source input", body:"Combine notes, DOCX, PDF, images and supporting files as source material."},
  {icon: ShieldCheck, title:"Workspace standards", body:"Centralise terminology, writing style, language variant and required sections."},
  {icon: FileText, title:"Editable Word output", body:"Every document exports as an editable Microsoft Word file."},
  {icon: FolderOpen, title:"Document library", body:"Organise generated documents with search, filters and status."},
  {icon: GitBranch, title:"Version history", body:"Retain previous document versions with the template version used."},
  {icon: Users2, title:"Team workspaces", body:"Employees share approved templates and standards across the team."},
];

export default function Product() {
  return (
    <MarketingPage eyebrow="Product" title="A structured documentation workflow, not prompt engineering." subtitle="Fexidoc is a controlled documentation environment. Configure your standards once, then use them across every document your team creates.">
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {features.map((f) => (
          <div key={f.title} className="fx-panel p-6 fx-hover-panel">
            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-cyan-500/20 to-violet-500/20 flex items-center justify-center border border-cyan-400/20 mb-4"><f.icon size={18} className="text-cyan-300"/></div>
            <div className="font-display font-semibold text-slate-100 text-lg">{f.title}</div>
            <div className="text-slate-400 text-sm mt-2 leading-relaxed">{f.body}</div>
          </div>
        ))}
      </div>
    </MarketingPage>
  );
}
